import { defineStore } from "pinia";
export type LoginMethod =
  | "email"
  | "google"
  | "twitter"
  | "facebook"
  | "auth-facebook"
  | "apple"
  | "telegram"
  | "telegram_widgets"
  | null
  | undefined;

export interface TnewUserNextAction {
  action: string;
  params: any;
  next_token: string;
  token: string;
  userInfo: string;
  required: 1 | undefined;
}
export interface LoginResponse {
  token?: string;
  activation_token?: string;
  next_token?: string;
  userInfo: any;
  method?: LoginMethod;
  nextAction?: [];
  isHistory?: boolean;
  tgManualLogin?: boolean;
  loginMethod?: LoginMethod;
}
export const useUserStore = defineStore("user", {
  state: (): {
    isLogin: boolean;
    hideTelegramGuide: "0" | "1"; // 0:展示; 1:隐藏;
    token: string;
    activationToken: string;
    userInfo: any;
    faceBookIsLoadLogin: boolean;
    telegramIsLoadLogin: boolean;
    shareOpenConfig: any;
    loginResponse: any;
    inviterCode: string;
    loginMethod: string;
  } => {
    return {
      isLogin: false,
      hideTelegramGuide: "0",
      token: "",
      activationToken: "",
      userInfo: null,
      faceBookIsLoadLogin: false,
      telegramIsLoadLogin: false,
      shareOpenConfig: {},
      loginResponse: {},
      inviterCode: "",
      loginMethod: "",
    };
  },
  actions: {
    async handLoginResponse(res: LoginResponse) {
      const equipment = useEquipmentStore();
      const {
        userInfo,
        activation_token,
        token,
        nextAction,
        next_token,
        doneActions,
      } = res as any;
      this.handleLoginSuccess(res);
    },
    // 登录成功
    async handleLoginSuccess(res: LoginResponse) {
      const user = useUserStore();
      const equipment = useEquipmentStore();
      const route = useRoute();
      const router = useRouter();
      const { method, token, next_token, userInfo, isHistory } = res;
      console.log("handleLoginSuccess", res);
      this.token = token as string;
      const svToken = useCookie("sv-token", {
        httpOnly: false,
        maxAge: 15 * 60, // 15分钟
      });
      svToken.value = token;

      this.loginResponse = res; //记录响应数据更新用户信息

      this.isLogin = true;

      if (res.method !== "auth-facebook") {
        //授权登录在callback-facebook文件单独处理
        handlerNextStepFn();
      }
    },
    setShareOpenConfig(config: any) {
      this.shareOpenConfig = config;
    },
    setinviterCodeFn(code: string) {
      if (!this.inviterCode) {
        this.inviterCode = code;
      }
    },
  },
  persist: [
    {
      pick: ["isLogin", "shareOpenConfig", "loginResponse", "inviterCode"],
      storage: piniaPluginPersistedstate.localStorage(),
    },
    {
      pick: [],
      storage: piniaPluginPersistedstate.sessionStorage(),
    },
  ],
});
